<template>
<div>

    <div class="industryitem"  @mouseover="onpic()" @mouseout="pic()" :class="{lastitem:index==0}" :style="{width:industry.width+'px',height:industry.height+'px',background:'url('+industry.pic+') no-repeat','background-size':'100% 100%'}">
        <div class="itemall" :class="{onshow:alive}" :style="{width:industry.width-28+'px',height:industry.height-28+'px'}">
          <div class="itemcontents">
            <router-link  :to="{ name: 'industryinfo', params: { id: industry.id }}" >
            <div>
              <p class="itemcontentstitle">
              {{industry.title}}
              </p>
              
                <router-link class="itemcontentsa" :to="{ name: 'industryinfo', params: { id: industry.id }}" tag="span">查看更多</router-link>
              
            </div>
            </router-link>
            
          </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
  data(){
    return{
      alive:false,
      industrylist:{}
    }
  },
  props:['industry','index'],
  methods:{
    onpic:function(){
      this.alive=true
    },
    pic:function(){
      this.alive=false
    },
    
  }
}
</script>

<style scoped>
  .industryitem{
    float: left;
    overflow: hidden;
    /* margin-right: 9px; */
    margin-bottom: 20px;
    border-radius: 10px;
  }
  .lastitem{
     margin-right: 0;
  }
  .industryitem .itemall{
    padding: 14px;
    background-color: #000;
    opacity:0.6;
    display: none;
  }
   .industryitem .itemall.onshow{
     display: block;
   }
  .industryitem .itemall .itemcontents{
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background-color: #000;
    border: 1px solid #efefef;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }
  .industryitem .itemall .itemcontents .itemcontentstitle{
    font-size: 30px;
    margin-bottom: 20px;
  }
  .industryitem .itemall .itemcontents .itemcontentsa{
    font-size: 20px;
    padding: 1px 18px;
    border-radius: 13px;
    border:1px solid #efefef;
}
  div{
    
    color: #fff;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsIndustryItem.vue